import * as React from 'react';

import { RouteComponentProps } from 'react-router';

import { LayoutHeader } from 'components/Layout';
import { ImageCheckGreen, ImageDisabled, ImageFreeze } from 'images/index';

import './WalletFreeze.scss';

type WalletFreezeProps = RouteComponentProps<{}>;

export class WalletFreeze extends React.Component<WalletFreezeProps, {}> {
  render() {
    const { history } = this.props;
    return (
      <div className="o-container o-container--fluid">
        <LayoutHeader actionIcon="ic-close" actionHandler={history.goBack}>
          <h1 className="o-layout-header-title">Akses ditutup</h1>
        </LayoutHeader>

        <div className="wallet-freeze__logo">
          <img src={ImageFreeze}/>
        </div>

        <div className="wallet-freeze__content">
          Mulai tanggal 15 Januari 2018 Top-up saldo, Invoice, Transfer ke Teman, dan Belanja dengan Saldo Kaspay sudah tidak dapat dilakukan.
        </div>

        <div className="wallet-freeze__content-list o-container__flex-row">
          <div className="o-container__flex-row o-container__flex--full o-container__flex-horizontal--center">
            <i className="wallet-freeze__content-list-icon ic-wallet-add o-title-2"/>
            Top-up saldo
          </div>
          <img src={ImageDisabled}/>
        </div>

        <div className="wallet-freeze__content-list o-container__flex-row">
          <div className="o-container__flex-row o-container__flex--full o-container__flex-horizontal--center">
            <i className="wallet-freeze__content-list-icon ic-invoice o-title-2"/>
            Invoice
          </div>
          <img src={ImageDisabled}/>
        </div>

        <div className="wallet-freeze__content-list o-container__flex-row">
          <div className="o-container__flex-row o-container__flex--full o-container__flex-horizontal--center">
            <i className="wallet-freeze__content-list-icon ic-wallet-transfer o-title-2"/>
            Transfer ke Teman
          </div>
          <img src={ImageDisabled}/>
        </div>

        <div className="wallet-freeze__content-list o-container__flex-row">
          <div className="o-container__flex-row o-container__flex--full o-container__flex-horizontal--center">
            <i className="wallet-freeze__content-list-icon ic-cart o-title-2"/>
            Belanja
          </div>
          <img src={ImageDisabled}/>
        </div>

        <div className="wallet-freeze__content-list o-container__flex-row">
          <div className="o-container__flex-row o-container__flex--full o-container__flex-horizontal--center">
            <i className="wallet-freeze__content-list-icon ic-redeem o-title-2"/>
            Transfer ke Bank
          </div>
          <img src={ImageCheckGreen}/>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Wallet/WalletFreeze/WalletFreeze.tsx